module.exports = __webpack_public_path__ + "img/album03_12.f17df890.jpg";